// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"6ff4d3d3","239":"c65b3a33","732":"31a3afd5","977":"b3083583"}[chunkId] + ".chunk.js";
};